import React from 'react';

/** Tappeer mascot — inline SVG, always transparent background. */
export function TappeerAvatar({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      width='254'
      height='152'
      viewBox='0 0 254 152'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={style}
      aria-hidden='true'
    >
      <path
        d='M214.531 25.5951L223.975 32.7046C223.975 32.7046 236.337 26.0828 236.564 21.2524C236.794 16.4213 233.974 11.8597 230.702 10.3437C227.432 8.82728 224.783 9.17854 221.476 10.6154C218.171 12.0519 214.531 25.5951 214.531 25.5951Z'
        fill='#474747'
      />
      <path
        d='M37.0242 127.504C37.6874 119.003 39.677 104.504 39.677 104.504L63.6172 104.502C63.6172 104.502 56.9604 120.245 56.9304 128.503C56.9004 136.762 60.9056 148.504 58.9215 150.004C56.9374 151.504 47.5771 152.444 41.6681 150.004C35.759 147.564 36.3609 136.004 37.0242 127.504Z'
        fill='#0A0A0A'
      />
      <path
        d='M2.85924 36.2201C6.61289 26 10.9749 22.0794 21.8302 16.8249C32.6854 11.5705 53.2742 0.5 101.693 0.5C124.695 0.5 142.87 6.26874 142.612 6.62177C132.145 20.918 125.93 30.6766 121.138 46.4299C116.345 62.1831 117.115 94 117.115 94C117.115 94 88.2144 106.108 62.2581 108.193C36.3019 110.278 30.8159 101.06 30.8159 101.06C30.8159 101.06 26.9057 84.4529 23.8277 78.0906C20.7498 71.7284 9.86008 67.8834 2.85924 63.7984C0.386089 57.1672 -0.894413 46.4402 2.85924 36.2201Z'
        fill='white'
        stroke='black'
        strokeOpacity='0.05'
      />
      <path
        d='M21.6325 74.595C16.4224 69.1486 2.125 60.0068 2.125 60.0068C2.125 60.0068 2.76033 80.6368 3.62948 91.0068C4.49863 101.377 6.981 112.988 9.12797 123.687C11.2749 134.387 14.6276 150 17.128 151.006C19.6284 152.012 29.7739 151.39 32.1734 149.95C34.573 148.51 34.9274 133.159 34.6637 123.687C34.4 114.215 36.374 106.572 34.6517 97.7287C32.9294 88.885 26.8426 80.0413 21.6325 74.595Z'
        fill='#0A0A0A'
      />
      <path
        d='M132.12 149.501C132.12 149.501 122.122 154.515 113.624 149.504C113.624 149.504 111.031 144.225 111.612 128C112.113 114.025 116 94.5 116 94.5C116 94.5 116.72 59.5252 119.916 43.5125C123.112 27.4999 134.002 7.28755 139.5 4.99976C156.842 -2.22024 188.214 3.90472 207.113 11.9975C226.848 20.4484 246.582 44.2425 251.334 61.4998C256.086 78.7572 250.735 109.031 251.334 117.5C252.112 128.5 248.612 129 248.612 129C248.612 129 247.112 129.5 240.612 129.5C234.112 129.5 234.112 129.5 231.811 128C229.509 126.5 231.34 111.13 227.175 102.88C224.577 97.732 220.089 90.1918 211.329 86.4406C202.569 82.6894 194.428 86.4048 183.596 86.3814C172.765 86.3608 164.226 75.9242 164.226 75.9242C164.226 75.9242 162.12 86.3649 162.12 93.5032C162.12 100.642 162.12 106.9 162.12 115.036C162.12 123.171 165.612 147.002 165.612 149.501C165.612 151.999 148.009 152.999 146.315 149.501C144.62 146.002 141.886 132.717 140.617 120.002C139.347 107.286 139.617 88.0017 139.617 88.0017C139.617 88.0017 138.123 106.786 136.62 119.502C135.118 132.217 132.12 149.501 132.12 149.501Z'
        fill='#0A0A0A'
      />
      <path
        d='M191.831 30.5653L182.388 37.6749C182.388 37.6749 170.025 31.0531 169.798 26.2226C169.569 21.3915 172.388 16.8299 175.661 15.3139C178.931 13.7975 181.58 14.1488 184.887 15.5856C188.191 17.0221 191.831 30.5653 191.831 30.5653Z'
        fill='#474747'
      />
      <path
        d='M202.667 74.9008C204.524 74.3517 205.8 73.7444 206.715 72.0369C207.63 70.3296 207.428 68.9301 206.856 67.0803C206.282 65.2296 204.568 63.3889 203.014 62.5068C201.463 61.6254 200.362 61.2562 198.581 61.3899C196.801 61.5236 193.888 62.9699 193.031 64.7066C192.176 66.4442 192.318 67.8143 192.892 69.665C193.463 71.5148 194.676 73.1348 196.732 74.2369C198.788 75.337 200.808 75.4491 202.667 74.9008Z'
        fill='#F39EE5'
      />
      <path
        d='M227.482 64.1322C229.732 59.0977 227.474 53.1927 222.44 50.943C217.405 48.6933 211.5 50.9509 209.25 55.9851C207 61.0195 209.258 66.9245 214.292 69.1743C219.327 71.424 225.232 69.1666 227.482 64.1322Z'
        fill='white'
      />
      <path
        d='M225.807 64.603C227.556 60.6872 225.801 56.0946 221.885 54.3447C217.969 52.5947 213.377 54.3508 211.628 58.2668C209.876 62.1817 211.633 66.7752 215.548 68.5242C219.464 70.2743 224.056 68.5181 225.807 64.603Z'
        fill='black'
      />
    </svg>
  );
}

TappeerAvatar.displayName = 'TappeerAvatar';
